export var TYPES = {
  standard: 'standard',
  success: 'success',
  destructive: 'destructive',
  warning: 'warning',
  premium: 'premium',
  preview: 'preview',
  dark: 'dark'
};
var dataHookPrefix = 'floating-notification';
export var dataHooks = {
  button: "".concat(dataHookPrefix, "-button"),
  textButton: "".concat(dataHookPrefix, "-text-button"),
  notificationText: "".concat(dataHookPrefix, "-text"),
  closeButton: "".concat(dataHookPrefix, "-close-button")
};